import React, { useEffect, useMemo, useState } from "react";
import { Box, Paper, Typography, Divider } from "@material-ui/core";
import BranchSelect from "../../Components/BranchSelect";
import DateRangeBar from "../../Components/DateRangeBar";
import ExportButtons from "../../Components/ExportButtons";
import DataTable from "../../Components/DataTable";
import { Api } from "../../api/client";
import { money, num, pct } from "../../utils/format";
import { todayISO, daysAgoISO } from "./_date";

export default function RankingProductos(){
  const [branches, setBranches] = useState([]);
  const [branchId, setBranchId] = useState("");
  const [range, setRange] = useState({ from: daysAgoISO(7), to: todayISO() });

  const [rows, setRows] = useState([]);

  const params = useMemo(()=>({
    from: range.from, to: range.to, branch: branchId
  }), [range, branchId]);

  useEffect(()=>{
    Api.branches()
      .then(res => setBranches(res.data))
      .catch(()=> setBranches([{id:"", nombre:"Todas"}]));
  }, []);

  useEffect(()=>{
    async function load(){
      try{
        const r = await Api.productsRanking(params);
        const list = Array.isArray(r) ? r : (r?.data || []);
        setRows(list);
      }catch(e){
        console.error(e);
        setRows([]);
      }
    }
    load();
  }, [params]);

  const columns = [
    { key:"producto", label:"Producto" },
    { key:"categoria", label:"Categoría" },
    { key:"cantidad", label:"Cantidad", render:r=>num(r.cantidad) },
    { key:"ingreso", label:"Ingresos", render:r=>money(r.ingreso) },
    { key:"participacion", label:"Participación", render:r=>pct(r.participacion) },
    { key:"bajaRotacion", label:"Baja rotación", render:r=> r.bajaRotacion ? "Sí":"No" },
    { key:"extremo", label:"Extremo", render:r=> r.extremo ? "Sí":"No" },
  ];

  return (
    <Paper style={{padding:18, borderRadius:14}}>
      <Typography variant="h6" style={{fontWeight:900}}>Ranking por producto</Typography>
      <Divider style={{margin:"12px 0"}}/>

      <Box display="flex" gridGap={12} flexWrap="wrap">
        <BranchSelect value={branchId} options={branches} onChange={setBranchId}/>
        <DateRangeBar from={range.from} to={range.to} onChange={setRange}/>
        <ExportButtons filename={`ranking_productos_${params.from}_a_${params.to}.csv`} rows={rows}/>
      </Box>

      <Box mt={2}>
        <DataTable columns={columns} rows={rows}/>
      </Box>
    </Paper>
  );
}